export default "__VITE_ASSET__6a35974a__"